export default __webpack_public_path__ + "static/media/tutorial.70cae330.svg";